module.exports = "https://cdn.thelire.com/ins/resource/icon_golden_followers2.9ffe0598c6a69261b587f299aac719e7.png";